import Vue from "vue";
import VueGtag from "vue-gtag";
import router from '@/router/index'

Vue.use(VueGtag, {
    config: { id: "G-XRM6NS7YNK" },
}, router);
